'use client'

import React, { useState } from 'react'
import { Button, useDocumentInfo } from '@payloadcms/ui'
import { errMessage } from '../../lib/errors'

/**
 * Controllo admin per la edit view dei Post (slot beforeDocumentControls): pubblica il post sulla
 * Pagina Facebook del tenant CHIAMANDO POST /api/publish-to-facebook. Funziona anche se l'auto-publish
 * è disattivo (o il post è in opt-out): il trigger manuale è esplicito. Idempotente: se già pubblicato
 * avvisa senza creare doppioni.
 */
const ENDPOINT = '/api/publish-to-facebook'

export default function PublishToFacebook() {
  const { id } = useDocumentInfo()
  const [busy, setBusy] = useState(false)

  // Solo nella edit view di un documento esistente (in "create" non c'è id).
  if (!id) return null

  const publish = async (force = false) => {
    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ id, force }),
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) {
        window.alert(`Errore pubblicazione Facebook: ${data?.error || res.status}`)
        return
      }
      if (data?.reason === 'already-published') {
        const confirmed = window.confirm(
          'Questo articolo è già stato pubblicato su Facebook. Vuoi creare una nuova pubblicazione con i contenuti e l’anteprima attuali?\n\nIl post Facebook precedente non verrà eliminato né modificato.',
        )
        if (confirmed) await publish(true)
        return
      }
      if (data?.skipped) {
        window.alert(`Non pubblicato (${data?.reason || 'saltato'}).`)
        return
      }
      window.alert('Pubblicato su Facebook ✓')
      window.location.reload()
    } catch (error: unknown) {
      window.alert(`Errore pubblicazione Facebook: ${errMessage(error)}`)
    }
  }

  const onClick = async () => {
    setBusy(true)
    try {
      await publish(false)
    } finally {
      setBusy(false)
    }
  }

  return (
    <Button buttonStyle="secondary" size="small" onClick={onClick} disabled={busy}>
      {busy ? 'Pubblicazione…' : 'Pubblica su Facebook'}
    </Button>
  )
}
